import { HashLink } from 'react-router-hash-link';
import styles from './GoBackSection.module.css';

export default function GoBackSection(props) {
  return (
    <HashLink className={styles.icon} to={`/#${props.section}`}>
      <i class="fa fa-arrow-left"></i>
    </HashLink>
  )
}